import { DataInterop } from '@silvertours/front-shared';

type AuthorProps = {
  name: string;
  text: string;
  prefix: string;
  role: string;
  url?: string;
  worksFor?: string;
  knowsAbout?: string[];
  type?: string;
};

export const AuthorData = (author: AuthorProps) => {
  const { name, role, url, worksFor, knowsAbout, type = 'Person' } = author;

  const authorData = {
    '@type': type,
    name,
    jobTitle: role,
    ...(url && { url }),
    ...(worksFor && {
      worksFor: {
        '@type': 'Organization',
        name: worksFor,
      },
    }),
    ...(knowsAbout && knowsAbout.length > 0 && { knowsAbout }),
  };

  return (
    <DataInterop.StructuredData data={authorData} type={type} includeContext />
  );
};
